import { PingCard, Typography } from 'mobily-ui-library/lib';
import { useTranslation } from 'react-i18next';
import moment from 'moment';
import './PingCard.scss';

type PingCardProps = {
  rtl: boolean;
  game: any;
  currentRegion: any;
}

function PingCardComponent({ rtl, game, currentRegion }: PingCardProps) {
  const { t } = useTranslation();
  const dateTime = moment().format('M/DD/YYYY HH:mm');

  const gameResult = game.gameResults.filter((item: any) => {
    return rtl ? item.region_ar === currentRegion : item.region_en === currentRegion;
  })[0]

  const ping = gameResult.ping_Result[Math.floor(Math.random() * gameResult.ping_Result.length)]

  return (
    <section className={rtl ? 'Modal__section ModalArabic' : 'Modal__section'}>
      <Typography rtl={rtl} className='Modal__title'>{t('ping_result')}</Typography>
      <PingCard
        rtl={rtl}
        ping={ping}
        city={rtl ? gameResult.region_ar : gameResult.region_en}
        dateTime={dateTime}
        regionTitle={t('region')}
        dateTimeTitle={t('date_time')}
        avgerageTitle={t('average_time')}
        averageDescription={t('pingcard_description')}
        gameTitle={game.gameTitle}
        gameImage={require(`../../assets/img/${game.gameTitle}.png`)}
      />
    </section>
  )
}

export default PingCardComponent